import { PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";
import { productsClient } from "@core/clients";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ProductsQueryParams, ProductResults } from "@core/types";

const useGetProductsQuery = (props: ProductsQueryParams, options: UseQueryOptions<ProductResults> = {}) => {
  return useQuery<ProductResults, any>(
    ["products", props],
    async () => {
      return await productsClient.getProducts(props);
    },
    {
      cacheTime: PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useGetProductsQuery;
